import template from './views/extended-list.tpl.html';
import ActionLogExtendedListViewController from './controllers/extended-list-controller';

export default {
    slug: 'action-log',
    title: 'Action log entries',
    visible: [
        "timestamp",
        "editor",
        "entity_display_name",
        "action",
        "meta_data"
    ],
    permanentFields: [
        'id',
        'action',
        'entity'
    ],
    transformers: {},
    templates: {
        meta_data(row, col, store) {
            switch (_.lowerCase(row.action)) {
                case 'created':
                case 'updated':
                    let out = store.ng.translator.instant('action-log.store.templates.meta_data.changed_fields'),
                        fieldsForOut = [];

                    fieldsForOut = _.map(row.meta_data, (field) => {
                        return field.label;
                    });

                    out += fieldsForOut.sort().join(', ');

                    return out;
                default:
                    return '';
            }
        },
        editor(row, col, store) {
            let out = row.editor.name;

            if (row.editor.roles) {
                out += ' <i class="work-sans">(' + row.editor.roles + ')</i>';
            }

            return out;
        }
    },
    listview: 'ActionLogEntriesListView',
    extendedListView: true,
    customTableContainerClass: 'table-changelog',
    extendedListViewTemplate: template,
    extendedListController: 'ActionLogExtendedListViewController',
    locales: [],
    columns: [],
    extendedListViewCustomCellClass: 'changelog-details-wrapper data-list',
    tooltipColumns: [
        'meta_data',
        'editor'
    ],
    sort: {
        timestamp: 'desc'
    },
    actions: {
        selected: [false]
    }
}



// WEBPACK FOOTER //
// ./src/app/store/action_log/state.js